import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface QuoteNotesPopupProps {
    showModal: boolean;
    notes: string;
    hideModal(): void;
    update(note: string): void;
    saveModal(): void;
}

interface QuoteNotesPopup {

}

export default class QuoteNotePopup extends React.Component<QuoteNotesPopupProps, QuoteNotesPopup> {
    constructor(props: any) {
        super(props);

        this.state = {


        };

    }

    handleChange = (e: any) => {
        let notes = e.target.value;

        this.props.update(notes);
    }

    hideEditNotesModal = () => {
        this.props.hideModal();
    }

    saveEditNotes = () => {
        this.props.saveModal();
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <Modal show={this.props.showModal} onHide={this.hideEditNotesModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Edit Quote Note</Modal.Title>
                    <button type="button" className="close" onClick={this.hideEditNotesModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    Note will appear under Item name when printing the Quote
                    <label className="input-group input-group__max--width" htmlFor="editNotes">
                        <span className="label">Notes</span>
                        <input className="input" type="text" maxLength={20} id="quoteNote" name="quoteNote" value={this.props.notes} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.saveEditNotes}>Save</button>
                </Modal.Footer>
            </Modal>

        )
    }

}